module.exports = __webpack_public_path__ + "static/img/karticekorisnikazip5.04eefe0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/kup/tutorial/karticekorisnikazip5.png
// module id = +jhl
// module chunks = 0